export enum GamificationBadgeCategoryType {
  WEEKLY = 'WEEKLY',

  SPECIAL = 'SPECIAL',

  PERFORMANCE = 'PERFORMANCE',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/gamification-badge-category-type.ts